import { Supplier, SupplierInfo } from "./types";
import { Form, FormOptions } from "../PageBase";
import {
    convertEmailRecipientTextListIntoObject,
    EmailRecipientsTextList,
    findInfoIndex,
    getFormObjectFromEntity,
    getInfoFormFields

} from "../utils";

export interface SupplierInfoFormObject {
    fruit_type: string;
    report_type: string;
    email_recipients: EmailRecipientsTextList;
}

export const defineSupplierInfoFormCreate = (onSaveSupplier: (supplier: Supplier) => void) => (formOptions: FormOptions | undefined, supplier: Supplier | undefined) => {
    const supplierInfoForm = getInfoFormFields(formOptions, supplier);

    const onSave = (formObject: SupplierInfoFormObject, entity: Partial<Supplier>) => {
        const supplierInfoIndex = findInfoIndex(entity, formObject.fruit_type, formObject.report_type);
        const supplierInfo = entity.infos?.[supplierInfoIndex] ?? {} as SupplierInfo;
        const fruit_type = formObject.fruit_type === "*" ? undefined : formObject.fruit_type;
        const report_type = formObject.report_type === "*" ? undefined : formObject.report_type;
        const email_recipients = convertEmailRecipientTextListIntoObject(formObject.email_recipients);

        const newSupplierInfo: SupplierInfo = {
            ...supplierInfo,
            supplier_id: entity.id!,
            fruit_type,
            report_type,
            report_status: "READY",
            email_recipients,
        };

        const newSupplierInfos: SupplierInfo[] = [
            ...(entity.infos || []),
        ];

        if (supplierInfoIndex >= 0) {
            newSupplierInfos[supplierInfoIndex] = newSupplierInfo;
        } else {
            newSupplierInfos.push(newSupplierInfo);
        }

        const supplier = {
            ...entity,
            infos: newSupplierInfos,
        };

        onSaveSupplier(supplier as Supplier);
    };

    const onDelete = (formObject: SupplierInfoFormObject, entity: Partial<Supplier>) => {
        const supplierInfoIndex = findInfoIndex(entity, formObject.fruit_type, formObject.report_type);
        const newSupplierInfos = [
            ...(entity.infos || []),
        ];

        if (supplierInfoIndex > -1) {
            newSupplierInfos.splice(supplierInfoIndex, 1);
        }

        const supplier = {
            ...entity,
            infos: newSupplierInfos,
        };

        onSaveSupplier(supplier as Supplier);
    };

    const onFieldValueChange = (field: string, value: any, formObject: Partial<SupplierInfoFormObject>, entity: Partial<Supplier>) => {
        if (field === "fruit_type") {
            return {
                ...getFormObjectFromEntity(entity, value, formObject.report_type),
                [field]: value,
            };
        }

        if (field === "report_type") {
            return {
                ...getFormObjectFromEntity(entity, formObject.fruit_type, value),
                [field]: value,
            };
        }

        return {
            ...formObject,
            [field]: value,
        } as SupplierInfoFormObject;
    };

    const supplierInfoModal: Form<SupplierInfoFormObject, Supplier> = {
        title: "Supplier Info",
        fields: supplierInfoForm,
        modalButtonLabel: "Add Email(s)",
        onSave,
        onDelete,
        getFormObjectFromEntity,
        onFieldValueChange
    };

    return supplierInfoModal;
};
